import { ReactNode, RefObject } from 'react'
import classNames from 'classnames'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Swiper as SwiperType } from 'swiper/types'
import { SwiperProps } from 'swiper/swiper-react'

import 'swiper/css'
import './Carrousel.scss'

const Carrousel = ({
  name,
  className,
  carrouselRef,
  settings,
  children,
  showLeftFade = false,
  showRightFade = false
}: CarrouselProps) => {
  return (
    <div className="swiper-container">
      {showLeftFade && <div className="swiper-fade-left" />}
      <Swiper
        ref={carrouselRef}
        className={classNames('carrousel', className)}
        {...settings}>
        {Array.isArray(children) ? (
          children.map((child, index) => (
            <SwiperSlide key={`${name}-${index}`}>{child}</SwiperSlide>
          ))
        ) : (
          <SwiperSlide>{children}</SwiperSlide>
        )}
      </Swiper>
      {showRightFade && <div className="swiper-fade-right" />}
    </div>
  )
}

export default Carrousel

export type TCarrousel = SwiperType

type CarrouselProps = {
  name: string
  className?: string
  carrouselRef?: RefObject<SwiperType>
  children?: ReactNode
  settings?: any
  showLeftFade?: boolean
  showRightFade?: boolean
} & SwiperProps
